export const lovenseLp = {
  hero: {
    imageAlt: "遠隔バイブ新オプション自由操作",
    headingLine1: "遠隔バイブ新オプション",
    headingLine2: "「完全コントロール 🎮️」登場！",
  },
  about: {
    title: "「完全コントロール」とは？",
    point1: "お気に入りの女の子をイかせたい",
    point2: "遠隔バイブでいじめたい",
    point3: "遠隔バイブでエッチしたい",
    descPrefix: "そんなあなたのために、遠隔バイブの新オプション「",
    descHighlight: "完全コントロール",
    descSuffix: "」が登場しました！",
    descLine2:
      "女の子が装着している遠隔バイブの振動の強さを、あなたの指先でリアルタイムにコントロールできます。",
    descLine3Prefix:
      "思うがままに遠隔バイブを動かして、お気に入りの女の子との遠隔エッチを楽しみましょう",
    lovenseIconAlt: "Lovense",
    imageAlt: "完全コントロール機能のイメージ",
  },
  step: {
    title: "女の子をイかせまくり♡",
    point1: "ゆっくりじわじわ焦らして遊ぶ",
    point2: "責め続けるドSなプレイを楽しむ",
    point3: "寸止めして一気に追い込む",
    desc: "あなたのテクニック次第で、さまざまなプレイを楽しめます！",
    imageAlt2: "コントロールステップ2",
    imageAlt3: "コントロールステップ3",
    imageAlt4: "コントロールステップ4",
    imageAlt5: "コントロールステップ5",
  },
  tuto: {
    title: "操作方法",
    descLine1:
      "「完全コントロール」は遠隔バイブの振動を30秒間、リアルタイムで自分の好きなようにコントロールできるオプションです！",
    descLine2Prefix: "ビデオ通話中、Lovenseのアイコン",
    descLine2Suffix:
      "をタップして「完全コントロール」を選択すると、スライダーで振動の強さを調整できます。",
    descLine3: "あなたの思うままに遠隔バイブを操作してみましょう！",
    imageAlt1: "完全コントロール操作画面1",
    imageAlt2: "完全コントロール操作画面2",
  },
} as const;
